import { AnyOfFieldDefinition, FieldType } from '@msdk/definitions'
import React from 'react'

import { useFieldValue } from '../../../hooks'
import { FieldProps } from '../../../models/form'
import { ConditionalFieldRenderer } from '../ConditionalFieldRenderer'
import { StringField } from '../StringField'

export function AnyOfField({ node, onChange }: FieldProps) {
  const [value, _] = useFieldValue(node, onChange)
  const fieldDef = node.value.fieldDefinition as AnyOfFieldDefinition

  node.value.state = 'Readonly'
  node.value.fieldDefinition = (value as any)?.type
    ? fieldDef.valueTypes.find((t) => t.fieldDefinitionType === (value as any).type)
    : node.value.fieldDefinition

  console.log(node.value.fieldDefinition)
  console.log((value as any)?.type)

  return (
    <>
      {(value as any)?.type && (
        <ConditionalFieldRenderer
          node={node}
          readonly={true}
          type={(value as any).type as FieldType}
          showLabel={true}
        />
      )}
      {!(value as any)?.type && <StringField node={node} onChange={() => {}} fieldArgs={{ showLabel: true }} />}
    </>
  )
}
